import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { createGlobalStyle } from 'styled-components'
import ReactModal from 'react-modal'

import media from '../../../../services/generateMediaQueries'
import { setGACustomEvent } from '../../../../services/analytics/google-analytics'

import {
  MAIN,
  ADD_CARD,
  REFER,
  POINTS_HISTORY,
  VOUCHERS,
  MESSAGES,
  MANAGE_CARDS,
  UPLOAD_AVATAR,
  FAQ_PAGE,
  MANAGE_PREFERENCES,
  SHARE_FEEDBACK,
  CHANGE_PASSWORD,
  UPDATE_PROFILE,
  TICKETS,
  POINTS_MECHANICS,
  SETTINGS,
  TRANSPORTATION,
  HELP_CENTER,
  TRANSPORTATION_ROUTES,
  FILTER_LOCATION,
  UPDATE_MISSING_DATA,
  MAP_SURVEY,
} from '../../../../services/data/profilePages.json'

import ProfilePage from '../../containers/ProfilePage'
import ReferPage from '../../containers/ReferPage'
import AddCardPage from '../../containers/AddCardPage'
import PointsHistoryPage from '../../containers/PointsHistoryPage'
import VouchersPage from '../../containers/VouchersPage'
import MessagesPage from '../../containers/MessagesPage'
import ManageCardsPage from '../../containers/ManageCardsPage'
import UploadAvatarPage from '../../containers/UploadAvatarPage'
import FrequentlyAskedPage from '../../containers/FrequentlyAskedPage'
import ManagePreferencesPage from '../../containers/ManagePreferencesPage'
import ShareFeedbackPage from '../../containers/ShareFeedbackPage'
import ChangePasswordPage from '../../containers/ChangePasswordPage'
import UpdateProfilePage from '../../containers/UpdateProfilePage'
import TicketsPage from '../../containers/TicketsPage'
import PointsMechanics from '../../containers/PointsMechanics'
import SettingsPage from '../../containers/SettingsPage'
import HelpCenterPage from '../HelpCenterPage/HelpCenterPage'
import TransportationPage from '../../containers/TransportationPage'
import TransportationRoutes from '../../containers/TransportationRoutes'
import FilterLocation from '../../containers/FilterLocation'
import MissingDataProfilePage from '../../containers/MissingDataProfilePage'
import MapSurvey from '../../containers/MapSurvey'

import * as ExploreApiService from '../../../../services/api/requests/Explore'

const GlobalStyle = createGlobalStyle`
  .sticky-modal-open {
    overflow: hidden;
    position: relative;
    height: 100%;
    border: 0px;

    &:focus {outline:0;}
  }
`
const StyledReactModal = styled(ReactModal)`
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  background: rgb(255, 255, 255);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  outline: none;
  width: 100%;
  max-width: 375px;
  height: 100%;
  opacity: 0;
  display: flex;
  flex-direction: column;
  transition: all var(--animation-duration) var(--animation-easing);

  & > .react-reveal {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('small')`
    max-width: unset;
  `}

  @media (max-width: 1024px) {
    background: ${props =>
      props.isHideBackground === '22'
        ? 'rgba(255, 255, 255, 0)'
        : 'rgb(255, 255, 255);'};
  }
`

const PageWrapper = styled.div`
  height: 100vh;
  overflow: hidden;
`

const overlay = {
  zIndex: 10020,
  background: 'rgba(0, 0, 0, 0.8)',
}

const pages = [
  {
    page: MAIN,
    component: ProfilePage,
  },
  {
    page: ADD_CARD,
    component: AddCardPage,
  },
  {
    page: REFER,
    component: ReferPage,
  },
  {
    page: POINTS_HISTORY,
    component: PointsHistoryPage,
  },
  {
    page: VOUCHERS,
    component: VouchersPage,
  },
  {
    page: MESSAGES,
    component: MessagesPage,
  },
  {
    page: MANAGE_CARDS,
    component: ManageCardsPage,
  },
  {
    page: UPLOAD_AVATAR,
    component: UploadAvatarPage,
  },
  {
    page: FAQ_PAGE,
    component: FrequentlyAskedPage,
  },
  {
    page: MANAGE_PREFERENCES,
    component: ManagePreferencesPage,
  },
  {
    page: SHARE_FEEDBACK,
    component: ShareFeedbackPage,
  },
  {
    page: CHANGE_PASSWORD,
    component: ChangePasswordPage,
  },
  {
    page: UPDATE_PROFILE,
    component: UpdateProfilePage,
  },
  {
    page: TICKETS,
    component: TicketsPage,
  },
  {
    page: POINTS_MECHANICS,
    component: PointsMechanics,
  },
  {
    page: SETTINGS,
    component: SettingsPage,
  },
  {
    page: HELP_CENTER,
    component: HelpCenterPage,
  },
  {
    page: TRANSPORTATION,
    component: TransportationPage,
  },
  {
    page: TRANSPORTATION_ROUTES,
    component: TransportationRoutes,
  },
  {
    page: FILTER_LOCATION,
    component: FilterLocation,
  },
  {
    page: UPDATE_MISSING_DATA,
    component: MissingDataProfilePage,
  },
  {
    page: MAP_SURVEY,
    component: MapSurvey,
  },
]

class MainView extends React.Component {
  componentDidUpdate(prevProps) {
    const { accessToken, displayProfileModal, profileModalPage } = this.props

    const {
      profileModalPage: prevProfileModalPage,
      accessToken: prevAccessToken,
    } = prevProps

    if (!accessToken && prevAccessToken !== accessToken) {
      displayProfileModal(false)
    }

    if (profileModalPage !== prevProfileModalPage) {
      const display =
        profileModalPage ||
        window.document.querySelector(
          `div:not(#${this.modalPortalId}) > .modal.open`,
        ) ||
        window.document.querySelector('.ReactModalPortal:not(:empty)')

      document
        .querySelector('html')
        .setAttribute('class', display ? 'sticky-modal-open' : '')
      document
        .querySelector('body')
        .setAttribute('class', display ? 'sticky-modal-open' : '')
    }
  }

  modalClose = async () => {
    const {
      match,
      push,
      accessToken,
      displayProfileModal,
      surveyData,
    } = this.props
    const { page, pageType } = match.params

    displayProfileModal(false)

    if (accessToken) {
      try {
        await ExploreApiService.sendSurveyFeedback(accessToken, {
          action: 'dismissed',
          answer: surveyData,
        })
      } catch (error) {
        console.log(error)
      } finally {
        await this.getSurveyAvailable(accessToken)
      }
    } else {
      await ExploreApiService.sendGuestSurveyFeedback({
        action: 'dismissed',
        answer: surveyData,
      })
    }

    setGACustomEvent('survey_skipped', {
      user_type: accessToken ? 'Basic' : 'Guest',
      platform: 'Web',
    })

    if (page === 'main' && ['faq', 'more'].indexOf(pageType) >= 0) {
      push('/')
    }
  }

  getSurveyAvailable = async accessToken => {
    const { setSurveyModalStatus } = this.props
    if (accessToken) {
      try {
        const surveyAvailable = await ExploreApiService.getSurveyAvailable(
          accessToken,
        )
        setSurveyModalStatus(surveyAvailable.data.toPrompt)
      } catch (error) {
        console.log(error)
      }
    }
  }

  render() {
    const {
      profileModalPage,
      showProfileModal,
      recoveryStep,
      ...restProps
    } = this.props
    const isInAppMaintenance =
      restProps &&
      restProps.location &&
      restProps.location.pathname === '/app-maintenance'
    const recoveryMode = recoveryStep > 0

    return (
      <>
        <GlobalStyle />
        <StyledReactModal
          isOpen={showProfileModal && !isInAppMaintenance}
          style={{ overlay }}
          onRequestClose={this.modalClose}
          closeTimeoutMS={150}
          shouldCloseOnOverlayClick={!recoveryMode}
          bodyOpenClassName="sticky-modal-open"
          htmlOpenClassName="sticky-modal-open"
          isHideBackground={`${profileModalPage}`}
        >
          <PageWrapper>
            {pages.map(page => {
              const { component: Component } = page
              return page.page === profileModalPage ? (
                <Component {...restProps} key={page.page} />
              ) : (
                <React.Fragment key={page.page} />
              )
            })}
          </PageWrapper>
        </StyledReactModal>
      </>
    )
  }
}

MainView.defaultProps = {
  profileModalPage: MAIN,
  showProfileModal: false,
}

MainView.propTypes = {
  profileModalPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currentPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showProfileModal: PropTypes.bool,
}

export default MainView
